var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/lodash/_defineProperty.js
// module id = 331
// module chunks = 1